// LinkedFieldsMap.jsx — "Every place a master field appears, verified".
// 1:1 port of drhp_linked_fields_map.html. Data comes live from
// /api/drhp-workspace/master/{ws}/linked-map (master values reflect what the
// user captured in the Master Data module). Built when "Review & Approve" runs.
import React, { useEffect, useState } from "react";
import { api } from "../lib/api.js";

const dotClass = (s) => (s === "ok" ? "st-ok" : s === "warn" ? "st-warn" : "st-err");
const tagClass = (s) => (s === "ok" ? "tg-synced" : s === "warn" ? "tg-pending" : "tg-mismatch");
const tagLabel = (s) => (s === "ok" ? "Synced" : s === "warn" ? "Pending" : "Mismatch");

export default function LinkedFieldsMap({ workspace }) {
  const [fields, setFields] = useState([]);
  const [sel, setSel] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.linkedMap(workspace)
      .then((d) => {
        const f = d.fields || [];
        setFields(f);
        setSel((s) => s || (f[0] && f[0].key));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };
  useEffect(load, [workspace]);

  const cur = fields.find((f) => f.key === sel) || fields[0];

  return (
    <div className="drhp-lf-root" data-testid="drhp-linked-map">
      <div className="lf-bar">
        <div className="lf-logo"><i className="ti ti-link" style={{ color: "#fff", fontSize: 17 }} aria-hidden="true" /></div>
        <div>
          <div className="lf-title">Linked Fields Map</div>
          <div className="lf-sub-t">Every place a master field appears — verified</div>
        </div>
        <button className="lf-recheck" onClick={load} data-testid="lf-recheck">
          <i className="ti ti-refresh" style={{ fontSize: 12 }} aria-hidden="true" /> Re-check all
        </button>
      </div>

      <div className="lf-body">
        <div className="picker">
          <div className="pk-lbl">Master fields</div>
          {loading && <div style={{ padding: "10px 14px", fontSize: 12, color: "#8a8a94" }}>Checking…</div>}
          {fields.map((f) => (
            <div key={f.key} className={`pk-i ${cur && cur.key === f.key ? "on" : ""}`}
              onClick={() => setSel(f.key)} data-testid={`lf-field-${f.key}`}>
              <div className="pk-n">
                <span className={`pk-dot ${dotClass(f.dot)}`} /> {f.label}
                <span className="pk-ct">{f.stats.total}</span>
              </div>
              <div className="pk-tok">{f.token}</div>
            </div>
          ))}
        </div>

        <div className="detail">
          {cur && (
            <>
              {cur.banner && (
                <div className="banner">
                  <i className="ti ti-alert-triangle" style={{ fontSize: 16, color: "#dc2626" }} aria-hidden="true" />
                  <div className="banner-t" dangerouslySetInnerHTML={{ __html: cur.banner }} />
                  <button className="banner-b" onClick={load} data-testid="lf-fix-all">Fix all</button>
                </div>
              )}
              <div className="dt-head">
                <div className="dt-val">
                  <div className="dt-n">{cur.label}</div>
                  <div className="dt-tok">{cur.token}</div>
                  <div className="dt-current">Master value: <b>{cur.value || "—"}</b></div>
                </div>
              </div>
              <div className="dt-stats">
                <div className="ds"><div className="ds-v">{cur.stats.total}</div><div className="ds-l">Total locations</div></div>
                <div className="ds"><div className="ds-v" style={{ color: "#16a34a" }}>{cur.stats.synced}</div><div className="ds-l">Synced</div></div>
                <div className="ds"><div className="ds-v" style={{ color: "#d97706" }}>{cur.stats.pending}</div><div className="ds-l">Pending</div></div>
                <div className="ds"><div className="ds-v" style={{ color: "#dc2626" }}>{cur.stats.mismatch}</div><div className="ds-l">Mismatch</div></div>
              </div>
              <div className="loc-lbl">Locations across the DRHP</div>
              {cur.locations.map((l, idx) => (
                <div className="loc" key={idx}>
                  <span className={`loc-st ${dotClass(l.status)}`} />
                  <div className="loc-mid">
                    <div className="loc-ch">{l.chapter} <span>· {l.uses}</span></div>
                    <div className="loc-ctx" dangerouslySetInnerHTML={{ __html: l.ctx }} />
                  </div>
                  <span className={`loc-tag ${tagClass(l.status)}`}>{tagLabel(l.status)}</span>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
